<!-- 隐私协议 -->
<template>
  <div>
    <div class="title">
      <template v-if="$route.params.type === 'owner'"
        >中交智运个人信息保护政策（货主版）</template
      >
      <template v-else-if="$route.params.type === 'consigner'"
        >中交智运个人信息保护政策（承运商版）</template
      >
      <template v-else-if="$route.params.type === 'driver'"
        >中交智运个人信息保护政策（司机版）</template
      >
      <template v-else>中交智运个人信息保护政策</template>
    </div>
    <PrivacyOwner v-if="$route.params.type === 'owner'"></PrivacyOwner>
    <PrivacyDriver v-else-if="$route.params.type === 'driver'"></PrivacyDriver>
    <PrivacyConsigner
      v-else-if="$route.params.type === 'consigner'"
    ></PrivacyConsigner>
    <Privacy v-else></Privacy>
  </div>
</template>

<script>
import Privacy from "../components/Privacy.vue";
import PrivacyOwner from "../components/PrivacyOwner.vue";
import PrivacyDriver from "../components/PrivacyDriver.vue";
import PrivacyConsigner from "../components/PrivacyConsigner.vue";

export default {
  data() {
    return {};
  },

  components: {
    Privacy,
    PrivacyOwner,
    PrivacyDriver,
    PrivacyConsigner,
  },

  computed: {},

  mounted() {},

  methods: {},
};
</script>
<style lang='scss' scoped>
.title {
    font-size: 16px;
    font-weight: 600;

    margin-bottom: 20px;

    text-align: center;

    color: #000;
}

</style>